import type {StoreNotification} from '../../../entities';
/* eslint-disable */
export const mapNotificationDetail = (notification: StoreNotification) => {
  if (!notification || !notification.notificationType) return null;

  switch (notification.notificationType.name) {
    case 'ONBOARDING_COMPLETED':
      return {
        message:
          'Bienvenido a TiendaDa. Aquí encuentras nuestro canal de tutoriales 😊',
        linkType: 'internal',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'PRO_PLAN_PAYMENT_SUCCEEDED':
      return {
        message: 'Es hora de despegar con las funcionalidades PRO 🚀',
      };
    case 'PRO_PLUS_PLAN_PAYMENT_SUCCEEDED':
      return {
        message: 'Es hora de despegar con las funcionalidades PRO+ 🚀',
      };
    case 'PRO_PLAN_FREE_TRIAL_SUCCEEDED':
      return {
        message: 'Es hora de despegar con las funcionalidades PRO 🚀',
      };
    case 'PRO_PLUS_PLAN_FREE_TRIAL_SUCCEEDED':
      return {
        message: 'Es hora de despegar con las funcionalidades PRO+ 🚀',
      };
    case 'PRO_PLAN_DOWNGRADED':
      return {
        message: '',
        linkType: '',
        link: '',
      };
    case 'PRO_PLUS_PLAN_DOWNGRADED':
      return {
        message: '',
        linkType: '',
        link: '',
      };
    case 'PRO_PLAN_FREE_TRIAL_DOWNGRADED':
      return {
        message: '',
        linkType: '',
        link: '',
      };
    case 'PRO_PLUS_PLAN_FREE_TRIAL_DOWNGRADED':
      return {
        message: '',
        linkType: '',
        link: '',
      };
    case 'STORE_DEMO_DAY':
      return {
        message: '',
        linkType: 'ternal',
        link: ``,
      };
    case 'STORE_ACTIVATION':
      return {message: '', linkType: 'ternal', link: ``};
    case 'BASIC_FEATURES_EXPLANATION':
      return {message: '', linkType: 'ternal', link: ``};
    case 'STORE_SUPPORT_CONTACT':
      return {
        message:
          'Si tienes alguna pregunta, sólo debes hacer clic al botón de Ayuda y podremos conversar.',
      };
    case 'USER_LOGGED_IN_2_TIMES':
      return {
        message:
          'Realiza tus consultas en directo en nuestro DEMO DAY, inscríbete aquí 👇🏼',
        linkType: 'external',
        link: 'https://forms.gle/diTbXDTzVGjc8i9L8',
      };
    case 'USER_LOGGED_IN_5_TIMES':
      return {
        message:
          'Te dejamos algunas recomendaciones para la creación de tu tienda 💪🏼',
        linkType: 'external',
        link: `https://drive.google.com`,
      };
    case 'USER_LOGGED_IN_20_TIMES':
      return {message: '', linkType: 'ternal', link: ``};
    case 'ORDER_1_CREATED':
      return {
        message:
          'Has obtenido tu primer pedido en TiendaDa  🙌🏻. Ahora vamos por más.',
        linkType: 'internal',
        link: notification.additionalData
          ? `/orders/${notification.additionalData.orderId}`
          : '',
      };
    case 'ORDER_8_CREATED':
      return {
        message:
          'Cuéntanos qué opinas de TiendaDa y ayúdanos a mejorar nuestro servicio 🙏🏼 Clic para accder a una breve encuesta.',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'ORDER_10_CREATED':
      return {
        message:
          '¡Felicidades! Has logrado 10 pedidos 🥳   Ahora queremos contarte sobre el módulo de gestión de pedidos y lo que puedes hacer, clic para ver un tutorial.',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'ORDER_30_CREATED':
      return {
        message:
          'Vamos por los 30 pedidos generados 🥳  en TiendaDa. A seguir creciendo  💪🏼 . Mira las funcionalidades de TiendaDA PRO',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'ORDER_50_CREATED':
      return {
        message:
          '😱  ¡50 pedidos generados! Y te falta aprovechar un recurso muy importante, la data de tus clientes. Empieza a armar campañas enfocadas de acuerdo a cada cliente. Clic para conocer cómo podrías aplicarlo',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'ORDER_100_CREATED':
      return {message: '', linkType: 'ternal', link: ``};
    case 'PRODUCT_1_CREATED':
      return {
        message:
          '¿Cómo te fue con la primera carga de producto? Nos ayudarías un montón realizando esta breve encuesta. Clic aquí 👇🏼',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    // case 'PRODUCT_6_CREATED':
    //   return {
    //     message: 'Con TiendaDa PRO puedes acceder a configuraciones avanzadas de productos. Prueba 1 mes GRATIS, clic aquí 🙋🏻‍♀️',
    //     linkType: 'internal',
    //     link: `?freeTrial=1`,
    //   };
    case 'PRODUCT_10_CREATED':
      return {
        message:
          'Configura tallas, colores, tamaños y más... Clic para mostrarte cómo funcionaría 👇🏼',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    // case 'PRODUCT_20_CREATED':
    //   return {
    //     message:
    //       'Con TiendaDa PRO puedes acceder a configuraciones avanzadas de productos. Prueba 1 mes GRATIS',
    //     linkType: 'internal',
    //     link: `?freeTrial=1`,
    //   };
    case 'PRODUCT_50_CREATED':
      return {
        message:
          'Con más de 50 productos puede ser muy trabajoso actualizar precios o detalles del producto 😬.  Por eso hemos creado la actualización masiva, clic aquí para conocer cómo funciona 👇🏼',
        linkType: 'external',
        link: notification.additionalData
          ? notification.additionalData.link
          : '',
      };
    case 'PRODUCT_80_CREATED':
      return {
        message: '',
        linkType: 'ternal',
        link: ``,
      };
    // case 'PRODUCT_100_CREATED':
    //   return {message: '', linkType: 'ternal', link: ``};
    case 'ORDER_CREATED':
      return {
        message: `Tienes un nuevo pedido 🙌🏻.  # Pedido ${
          notification.additionalData ? notification.additionalData.orderId : ''
        }`,
        linkType: 'internal',
        link: notification.additionalData
          ? `/orders/${notification.additionalData.orderId}`
          : '',
      };
    case 'ORDER_REVIEWED':
      return {
        message: 'Acabas de recibir una nueva reseña. Clic aquí para verla ➡️',
        linkType: 'internal',
        link: '/marketing/reviews',
      };
    case 'ORDER_REVIEW_REQUEST':
      return {
        message:
          'No te olvides de pedir una reseña 📝  a tu cliente. No hay nada mejor que la recomendación de un cliente.',
        linkType: 'internal',
        link: '/marketing/reviews',
      };
    case 'ORDER_PAID_AUTOMATICALLY':
      return {
        message: notification.additionalData
          ? `Tienes una nueva orden ${notification.additionalData.orderId} que ha sido pagada. Ir a revisar.`
          : '',
        linkType: 'internal',
        link: notification.additionalData
          ? `/orders/${notification.additionalData.orderId}`
          : '',
      };
      case 'MANUAL_ORDER_CREATED': {
        return {
          message: `Se a creado un pedido Manual 🙌🏻.  # Pedido ${
            notification.additionalData ? notification.additionalData.orderId : ''
          }`,
          linkType: 'internal',
          link: notification.additionalData
            ? `/orders/${notification.additionalData.orderId}`
            : '',
        };
      }
    // case 'SUCCESSFUL_LOGIN_1_TIME':
    // return {
    //   message: '',
    //   linkType: '',
    //   link: '',
    // };
    // case 'SUCCESSFUL_LOGIN_2_TIMES':
    //   return {
    //     message: '¿Ya participaste del Taller: Inicia en la venta digital con TiendaDa? No te lo puedes perder. Clic aquí para registrarte 🔝',
    //     linkType: 'external',
    //     link: notification.additionalData
    // ? notification.additionalData.link
    // : '',
    //   };
    case 'SUBSCRIPTION_7_DAY_LEFT_REACHED':
      return {
        message:
          'Tu plan PRO está por vencer 😬  Recuerda realizar el pago antes del vencimiento para no perder las funcionalidades PRO 🚀. Clic aquí para renovar.',
        linkType: 'internal',
        link: '/tiers-list',
      };
    case 'SUBSCRIPTION_3_DAY_LEFT_REACHED':
      return {
        message:
          'Te quedan sólo 3 días en tu plan PRO 😱 . Recuerda que tu renovación se activa cuando tu plan actual finalize 🤗. Clic aquí para renovar.',
        linkType: 'internal',
        link: '/tiers-list',
      };
    case 'SUBSCRIPTION_1_DAY_LEFT_REACHED':
      return {
        message:
          'Te queda 1 día en tu plan PRO 😬 . Recuerda renovarlo a tiempo para no perder las funcionalidades avanzadas. Clic aquí para renovar.',
        linkType: 'internal',
        link: '/tiers-list',
      };
    // case 'PRODUCT_UPLOADED_1_BY_REFERRAL':
    //   return {
    //     message: '¡Felicidades! Uno de tus referidos logró crear una cuenta y subir su primer producto. Recibiste 1 punto.',
    //   };
    // case 'ORDER_PLACED_1_BY_REFERRAL':
    //   return {
    //     message:notification.additionalData ? `${notification.additionalData.refereeName} ha realizado su primera venta gracias a ti. Recibiste ${notification.additionalData.storePoints} puntos.`:'',
    //   };
    // case 'STORE_SUBSCRIPTION_SUCCESS_BY_REFERRAL':
    //   return {
    //     message: notification.additionalData ? `${notification.additionalData.refereeName} acaba de dar un paso más y se volvió usuario PRO 🚀. Por referirl@ Recibiste ${notification.additionalData.storePoints} puntos! Sigue así y vuélvete PRO gratis 😉`:'',
    //   };
    case 'STORE_POINTS_EARNED_BY_REFERRAL':
      return {
        message:
          notification.additionalData &&
          notification.additionalData.businessEvent
            ? {
                PRODUCT_1_CREATED:
                  '¡Felicidades! Uno de tus referidos logró crear una cuenta y subir su primer producto. Recibiste 1 punto.',
                ORDER_1_CREATED: `${notification.additionalData.refereeName} ha realizado su primera venta gracias a ti. Recibiste ${notification.additionalData.storePoints} puntos.`,
                PRO_PLAN_PAYMENT_SUCCEEDED: `${notification.additionalData.refereeName} acaba de dar un paso más y se volvió usuario PRO 🚀. Por referirl@ Recibiste ${notification.additionalData.storePoints} puntos! Sigue así y vuélvete PRO gratis 😉`,
              }[notification.additionalData.businessEvent]
            : '',
      };
    // case '':
    //   return {
    //     message: '!Tienes 40 puntos acumulados! 🎉 Canjea tus puntos por una suscripción mensual de TiendaDa PRO',
    //     linkType: 'internal',
    //     link: '/profile/referral',
    //   };
    default:
      return null;
  }
};

export const notificationAdapter = (notifications: StoreNotification[]) => {
  return notifications.map(notification => {
    const additionalData = notification.additionalData && {
      ...notification.additionalData,
      orderId:
        notification.additionalData.orderId ||
        notification.additionalData.order_id,
    };

    return {
      ...notification,
      additionalData,
    };
  });
};
